// extracted by css-extract-rspack-plugin
export default {"root":"root-noho8G","topBar":"topBar-qA36Xp","main":"main-fcMOX3"};